import type { ReactNode } from "react";
import { cx } from "@/lib/cx";
import { Kbd } from "./Kbd";

/** A key combination with a short label: "[G] [I] Inbox". Used in empty states and footers. */
export function KeyHint({ keys, children, className }: { keys: string[]; children: ReactNode; className?: string }) {
  return (
    <span className={cx("inline-flex items-center gap-1.5 text-xs text-fg-subtle", className)}>
      <Kbd keys={keys} />
      <span>{children}</span>
    </span>
  );
}
